import { defineMessages } from "react-intl"

export const messages = defineMessages({
    "payment_status": {
        id: "payment.listing.payment_status",
        defaultMessage: "Payment status",
    },
    "payment_type": {
        id: "payment.listing.payment_type",
        defaultMessage: "Payment type",
    },
    "payment_amount": {
        id: "payment.listing.payment_amount",
        defaultMessage: "Payment amount",
    },
    "payment_source": {
        id: "payment.listing.payment_source",
        defaultMessage: "Payment source",
    },
    "payment_note": {
        id: "payment.listing.payment_note",
        defaultMessage: "Payment note",
    },
    "payment_currency": {
        id: "payment.listing.payment_currency",
        defaultMessage: "Currency",
    },
    "payment_captured_at": {
        id: "payment.listing.payment_captured_at",
        defaultMessage: "Captured at date",
    },
    "payment_voided_at": {
        id: "payment.listing.payment_voided_at",
        defaultMessage: "Voided at date",
    },
    "integration_key": {
        id: "payment.listing.payment_integration_key",
        defaultMessage: "Integration",
    },
    "data_3ds_status": {
        id: "payment.listing.data_3ds_status",
        defaultMessage: "3DS Status",
    },
    "data_3ds_requested": {
        id: "payment.listing.data_3ds_requested",
        defaultMessage: "3DS Requested",
    },
    "data_3ds_failed_reason": {
        id: "payment.listing.data_3ds_failed_reason",
        defaultMessage: "3DS Failed Reason",
    },
})


// WEBPACK FOOTER //
// ./src/common/search-filter/search/paymentFilters/messages.ts